import { render, staticRenderFns } from "./tableDepartment.vue?vue&type=template&id=385d915d&"
import script from "./tableDepartment.vue?vue&type=script&lang=js&"
export * from "./tableDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports